import type { MessageSchema } from '.';

const messages: MessageSchema = {
	selected_reservation_date: 'Ausgewähltes Reservierungsdatum',
	change_date: 'Datum ändern',
	reserve_with_voucher: 'Mit Gutschein(code) reservieren',
	redeem_your_vouchers_here: 'Lösen Sie hier Ihre Gutscheine ein!',
	redeem_your_vouchers_and_gift_vouchers_during_payment_step:
		'Geben Sie unten Ihre einzigartigen Gutscheincodes ein. Geschenkgutscheine können Sie beim Bezahlen einlösen.',
	cancel: 'Abbrechen',
	redeem: 'Einlösen',
	voucher_code: 'Voucher Code',
	from: 'Ab',
	per_person_short: 'pro Person',
	starting_from_short: 'ab',
	unable_to_redeem_voucher: 'Gutschein kann nicht eingelöst werden',
	view: 'Ansehen',
	book: 'Reservieren',
	ok: 'OK',
	more_info: 'Mehr Infos',
	swimwear_day: 'Badekleidungstag',
	filter_swimwear_days: 'Nach Badekleidungstagen filtern',
	add_extra_voucher: 'Extragutschein hinzufügen',
	make_your_choice: 'Treffen Sie Ihre Wahl',
	choose_from_options: 'Sie können aus {count} Optionen wählen',
	unavailable_in_active_locale_message: 'Achtung: Du wirst auf unsere englische Website weitergeleitet.',
	loading: 'Laden',
	reserve_with_bathcard: 'Reservieren mit Badekarte',
	i_have_a_gift_voucher: 'Ich habe einen Geschenkgutschein',
	back: 'Zurück',
	close: 'Schließen',
	more_information: 'Mehr Informationen',
	view_page: 'Seite ansehen',
	choose: 'Wählen',
	go_back: 'Zurück',
	previous_option: 'Vorherige Option',
	next_option: 'Nächste Option',
	arrangements_and_deals: 'Arrangements & Deals',
	choose_date: 'Datum wählen',
	clear_date: 'Datum löschen',
	choose_arrival_date: 'Anreisedatum wählen',
	prices_per_person: 'Preise gelten pro Person',
	prices_per_person_per_night: 'Preise gelten pro Person pro Nacht',
	availability_notice: 'Es ist noch Verfügbarkeit vorhanden!',
};

export default messages;
